import Vue from "vue";
import axios from "axios";
import router from "./router";
import store from "./store";

Vue.prototype.$http = axios;

let initToken = window.localStorage.getItem("token");
if (initToken) {
  setAuthHeader(initToken);
} else {
  clearAuthHeader();
}

export function authValid(to, from, next) {
  axios
    .head("/api/v1/auth/jwt/valid")
    .then(() => {
      next();
    })
    .catch(err => {
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 401:
            next({ name: "login" });
            break;
          case 403:
            next(from);
            break;
        }
      } else {
        next(false);
      }
    });
}

axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    switch (err.response.status) {
      case 401:
        router.push({ name: "login" });
        break;
    }
    return Promise.reject(err);
  }
);

// 设置Authorization header
export function setAuthHeader(token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  let claim = parseTokenClaim(token);
  store.commit("setClaim", claim);
}

function parseTokenClaim(token) {
  token = token.split(".")[1];
  let claim = window.atob(token);
  return JSON.parse(claim);
}

// 清除Authorization header
export function clearAuthHeader() {
  delete axios.defaults.headers.common["Authorization"];
  store.commit("setClaim", {});
}
